import { render, staticRenderFns } from "./maintainMsg.vue?vue&type=template&id=bba1c1b4&scoped=true"
import script from "./maintainMsg.vue?vue&type=script&lang=js"
export * from "./maintainMsg.vue?vue&type=script&lang=js"
import style0 from "./maintainMsg.vue?vue&type=style&index=0&id=bba1c1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba1c1b4",
  null
  
)

export default component.exports